module.exports = __webpack_public_path__ + "img/pro_three_5.f7987cd2.jpg";